/**
 * What a карась is made of and what colour it is.
 *
 * Far simpler than the livestock skins, on purpose: a fish is seen through
 * moving water at arm's length, so it gets three boxes and three colours and
 * nothing else. Bronze-olive along the back, pale underneath - which is what
 * a карась out of a Ukrainian pond actually looks like, and enough to read as
 * a fish from above and from the side both.
 *
 * No texture at all. The first version painted one, and a box with no UVs
 * written onto it samples the whole sheet across every face - so each side
 * would have shown a smear of all three colours. There is no detail here to
 * place, so there is nothing for an atlas to hold.
 */

import type { BoxSize } from "../player/skins.js";

/** The three boxes a карась is made of, in the same pixel units as a skin. */
export const KARAS_PARTS: {
  readonly body: BoxSize;
  readonly tail: BoxSize;
  readonly fin: BoxSize;
} = {
  // Deep through the body and blunt at both ends: a карась, not a pike.
  body: { w: 3, h: 5, d: 8 },
  tail: { w: 1, h: 5, d: 3 },
  fin: { w: 1, h: 2, d: 4 },
};

/** Body, fins, and the dark of the back. */
export const KARAS_COLOURS = {
  body: 0xb2a860,
  fin: 0x8f874e,
  back: 0x6d6c3a,
} as const;
